import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;

  .company-name {
    font-size: 24px;
    font-weight: 600;
  }

  .company-number {
    font-size: 16px;

    span {
      font-weight: 600;
    }
  }
`;

export const InvoiceHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .invoice-number {
    font-size: 24px;
    margin-bottom: 50px;
  }

  .invoice-date {
    span {
      font-weight: 600;
    }

    font-size: 16px;
  }
`;

export const BillInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  span {
    font-weight: 600;
  }

  div {
    display: flex;
    flex-direction: column;
  }

  .company-address {
    width: 60%;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;

  span {
    font-weight: 600;
  }
`;

export const ServiceDescription = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const ServiceItem = styled.div`
  width: 50%;

  &:last-of-type {
    text-align: end;
  }
`;

export const Amount = styled.div`
  width: 100%;
  text-align: end;
  padding: 30px 20px;
  border-radius: 10px;
  background-color: ${theme.colors.blue900};

  span {
    font-weight: 600;
  }
`;

export const PaymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  span {
    font-weight: 600;
  }

  .payment-info-title {
    margin-bottom: 15px;
  }
`;

export const Divisor = styled.hr`
  border: 1px solid ${theme.colors.gray400};
  margin: 15px 0;
`;

export const TitleStyled = styled.h1`
  font-size: 25px;
`;

export const SubTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 25px;
`;

export const HeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }
  img {
    height: 60px;
    margin-bottom: 40px;
  }
`;

export const Wrapper = styled.div`
  padding: 15px;
`;
